<template>
  <div>
    <Header></Header>
    <div id="main">

      <div id="menustores">

      </div>

      <div id="vitrine">
        <div class="container-fluid">
          <div class="row">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <h1>Confira nossos Descontos do Bem</h1>
                  <h4>Ajude nossos projetos com descontos imperdíveis!</h4>
                  <div class="searchbar">
                    <b-form inline>
                        <b-input v-model="searchText" class="mb-6 mr-sm-6 mb-sm-0" id="inlineFormInputName2" placeholder="Pesquise por Loja" />
                      <b-button variant="primary" @click="searchStore()"> {{ (isSearching) ? 'Aguarde...' : 'Buscar' }}</b-button>
                    </b-form>
                    <!-- <a class="advanced-search" href="">+ Busca Avançada</a> -->
                  </div>
                  <!-- <div class="categories-list" v-if="featuredStores.length == 0">
                    <h5>Aguarde, carregando...</h5>
                  </div>

                  <div class="categories-list" v-else>
                    <carousel :per-page="perPage" :mouse-drag="false" :pagination-enabled="false" :navigation-enabled="true">
                      <slide v-for="(store, s) in featuredStores" v-bind:key="s" v-if="store.image">
                        <router-link :to="'/descontosdobem/' + store.slug" class="category">
                          <img :src="store.image"/>
                        </router-link>
                      </slide>
                    </carousel>
                  </div> -->

                  <div class="categories-list" v-if="couponsVitrine.length == 0">
                    <h5>Aguarde, carregando...</h5>
                  </div>

                  <div class="categories-list" v-else>
                    <carousel :per-page="perPage" :mouse-drag="false" :pagination-enabled="false" :navigation-enabled="true">
                      <slide v-for="(coupon, s) in couponsVitrine" v-bind:key="s">
                        <div class="category" @click="openCouponModal(coupon)">
                          <span v-if="coupon.value > 100">R${{coupon.value}}</span>
                          <span v-else>{{coupon.value}}%</span>
                          <img :src="coupon.image"/>
                        </div>
                      </slide>
                    </carousel>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="products">
        <div class="container">

          <div class="row mb-4" v-if="favoriteStores.length > 0">
              <div class="col-md-12">
                <div class="title-section">
                  <h3>Lojas para Você</h3>
                  <span>Selecionamos algumas lojas com base nas suas preferências!</span>
                </div>
                <div class="row">

                  <div class="col-md-12 loading-coupons" v-if="stores.length == 0">
                    <h5>Aguarde, carregando...</h5>
                  </div>

                  <div v-else class="col-md-2 store" v-for="(store, c) in favoriteStores" :key="c">
                    <div class="image">
                      <router-link :to="getStoreUrl(store)"><img :src="store.logo"/></router-link>
                    </div>
                  </div>

                </div>
              </div>
          </div>

          <div class="row">
              <div class="col-md-12">
                <div class="title-section">
                  <h3>Categorias em Destaque</h3>
                  <span>Confira aqui as categorias que mais venderam essa semana!</span>
                </div>
                <div class="row">

                  <div class="col-md-12 loading-coupons" v-if="categories.length == 0">
                    <h5>Aguarde, carregando categorias...</h5>
                  </div>

                  <div v-else class="col-md-4 category" v-for="(category, c) in categories" :key="c">
                    <a target="_blank" @click="selectCategory(category.id)">
                      {{category.name}}
                    </a>
                  </div>
                </div>
              </div>
          </div>
          <div class="row mt-4">
              <div class="col-md-12">
                <div class="title-section">
                  <h3>Produtos em Destaque</h3>
                  <span>Confira aqui as melhores ofertas da semana!</span>
                </div>
                <div class="row">

                  <div class="col-md-12 loading-coupons" v-if="products.length == 0">
                    <h5>Aguarde, carregando...</h5>
                  </div>

                  <div v-else class="col-md-3 product" v-for="(product, c) in products" :key="c">
                    <a target="_blank" :href="product.link">
                      <div class="image">
                          <img :src="product.thumbnail"/>
                          <div class="price">
                            <!-- <span v-if="product.priceMax > product.priceMin">De {{formatCurrency(product.priceMax)}}</span> -->
                            <b>Por {{formatCurrency(product.price)}}</b>
                          </div>
                      </div>
                      <div class="info">
                        <!-- <span>{{product.category.name}}</span> -->
                        <h4>{{product.name}}</h4>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>

      <div id="stores">
        <div class="container">
          <div class="row">
              <div class="col-md-12">
                <div class="title-section">
                  <h3>Todas as Lojas</h3>
                  <span>Acesse as melhores lojas e aproveite nossos descontos!</span>
                </div>
                <div class="row">

                  <div class="col-md-12 loading-coupons" v-if="stores.length == 0">
                    <h5>Aguarde, carregando...</h5>
                  </div>

                  <div v-else class="col-md-2 store" v-for="(store, c) in stores" :key="c">
                    <div class="image">
                      <router-link :to="getStoreUrl(store)"><img :src="store.logo"/></router-link>
                    </div>
                  </div>

                </div>
              </div>
          </div>
        </div>
      </div>

      <!-- <div id="featured" v-if="partnersCoupons">
        <div class="container">
          <div class="row">
              <div class="col-md-12">
                <div class="title-section">
                  <h3>Destaques</h3>
                  <span>Os melhores cupons da semana!</span>
                </div>
                <div class="featured-coupons">

                  <div class="col-md-3 coupon">
                    <div class="image">
                      <div class="flag">Destaque</div>
                      <img src="https://via.placeholder.com/500x500"/>
                    </div>
                    <div class="categorie">
                      <span>Mobiles</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>Cupom 10% DESCONTO</h4>
                        <span>Na compra de um carro Hyundai</span>
                        <span class="value">10%</span>
                      </div>
                      <div class="action">
                        <button class="btn">Ver Cupom</button>
                        <button class="btn fav">*</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 coupon">
                    <div class="image">
                      <div class="flag">Destaque</div>
                      <img src="https://via.placeholder.com/500x500"/>
                    </div>
                    <div class="categorie">
                      <span>Mobiles</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>Cupom 10% DESCONTO</h4>
                        <span>Na compra de um carro Hyundai</span>
                        <span class="value">10%</span>
                      </div>
                      <div class="action">
                        <button class="btn">Ver Cupom</button>
                        <button class="btn fav">*</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 coupon">
                    <div class="image">
                      <div class="flag">Destaque</div>
                      <img src="https://via.placeholder.com/500x500"/>
                    </div>
                    <div class="categorie">
                      <span>Mobiles</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>Cupom 10% DESCONTO</h4>
                        <span>Na compra de um carro Hyundai</span>
                        <span class="value">10%</span>
                      </div>
                      <div class="action">
                        <button class="btn">Ver Cupom</button>
                        <button class="btn fav">*</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 coupon">
                    <div class="image">
                      <div class="flag">Destaque</div>
                      <img src="https://via.placeholder.com/500x500"/>
                    </div>
                    <div class="categorie">
                      <span>Mobiles</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>Cupom 10% DESCONTO</h4>
                        <span>Na compra de um carro Hyundai</span>
                        <span class="value">10%</span>
                      </div>
                      <div class="action">
                        <button class="btn">Ver Cupom</button>
                        <button class="btn fav">*</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 coupon">
                    <div class="image">
                      <div class="flag">Destaque</div>
                      <img src="https://via.placeholder.com/500x500"/>
                    </div>
                    <div class="categorie">
                      <span>Mobiles</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>Cupom 10% DESCONTO</h4>
                        <span>Na compra de um carro Hyundai</span>
                        <span class="value">10%</span>
                      </div>
                      <div class="action">
                        <button class="btn">Ver Cupom</button>
                        <button class="btn fav">*</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 coupon">
                    <div class="image">
                      <div class="flag">Destaque</div>
                      <img src="https://via.placeholder.com/500x500"/>
                    </div>
                    <div class="categorie">
                      <span>Mobiles</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>Cupom 10% DESCONTO</h4>
                        <span>Na compra de um carro Hyundai</span>
                        <span class="value">10%</span>
                      </div>
                      <div class="action">
                        <button class="btn">Ver Cupom</button>
                        <button class="btn fav">*</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 coupon">
                    <div class="image">
                      <div class="flag">Destaque</div>
                      <img src="https://via.placeholder.com/500x500"/>
                    </div>
                    <div class="categorie">
                      <span>Mobiles</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>Cupom 10% DESCONTO</h4>
                        <span>Na compra de um carro Hyundai</span>
                        <span class="value">10%</span>
                      </div>
                      <div class="action">
                        <button class="btn">Ver Cupom</button>
                        <button class="btn fav">*</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3 coupon">
                    <div class="image">
                      <div class="flag">Destaque</div>
                      <img src="https://via.placeholder.com/500x500"/>
                    </div>
                    <div class="categorie">
                      <span>Mobiles</span>
                    </div>
                    <div class="coupon-info">
                      <div class="info">
                        <h4>Cupom 10% DESCONTO</h4>
                        <span>Na compra de um carro Hyundai</span>
                        <span class="value">10%</span>
                      </div>
                      <div class="action">
                        <button class="btn">Ver Cupom</button>
                        <button class="btn fav">*</button>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="view-all">
                  <button class="btn">Ver Todos</button>
                </div>
              </div>
          </div>
        </div>
      </div> -->

      <div id="latest">
        <div class="container">
          <div class="row">
              <div class="col-md-12">
                <div class="title-section">
                  <h3>Cupons mais Recentes</h3>
                  <span>Os melhores descontos da semana!</span>
                </div>
                <div class="latest-coupons">

                  <div class="col-md-12 loading-coupons" v-if="couponsFeatured.length == 0">
                    <h5>Aguarde, carregando...</h5>
                  </div>

                  <div v-else class="col-md-6" v-for="(coupon, c) in couponsFeatured" v-bind:key="c">
                    <div class="row coupon" @click="openCouponModal(coupon)">
                      <div class="col-md-5">
                        <div class="image">
                          <img :src="coupon.image"/>
                        </div>
                      </div>
                      <div class="col-md-7">
                        <div class="categorie" v-if="coupon.category">
                          <span>{{coupon.category}}</span>
                        </div>
                        <div class="coupon-info">
                          <div class="info">
                            <h4>{{coupon.store}}</h4>
                            <span>{{coupon.description}}</span>
                            <span class="value" v-if="coupon.value > 100">R$ {{coupon.value}}</span>
                            <span class="value" v-if="coupon.value < 100 && coupon.value > 0">{{coupon.value}}%</span>
                            <span class="value" v-else>&nbsp;</span>
                          </div>
                          <div class="action">
                            <button @click="openCouponModal(coupon)" class="btn">Ver Desconto</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="view-all" v-if="couponsFeatured.length !== 0 && couponsFeatured.length !== coupons.length">
                  <button class="btn" @click="showMore()">Ver Mais</button>
                </div>
              </div>
          </div>
        </div>
      </div>

      <transition name="fade">
        <div v-if="showScrollButton" id="scrollToTop">
          <a href="" @click.stop.prevent="scrollToTop()">
            <font-awesome-icon :icon="['fas', 'chevron-circle-up']" size="lg" />
          </a>
        </div>
      </transition>
    </div>

    <CouponModal :coupon="selectedCoupon" ref="couponModal"></CouponModal>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
    <b-modal ref="mustLogin" hide-footer title="Você não está logado">
      <div class="d-block text-center">
        <h3>Olá! Você precisa estar logado para visualizar o cupom.</h3>
      </div>
      <b-btn class="mt-3" variant="outline-success" block @click="goToLogin">Entrar</b-btn>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">Fechar</b-btn>
    </b-modal>

    <b-modal id="searchModal" ref="searchModal" hide-footer title="Selecione um resultado">
      <div v-for="(store, s) in resultStores" :key="s">
        <div v-if="resultStores && resultStores.length > 0" class="d-block text-center store">
          <a :href="'/descontosdobem/store/' + store.slug">{{store.Info.name}}</a>
        </div>
      </div>
      <div v-if="!resultStores  || resultStores.length == 0" class="d-block text-center">
        <h5>Nenhuma loja encontrada.</h5>
      </div>
    </b-modal>
  </div>
</template>

<script>

import Header from './../includes/Header'
import Footer from './../includes/Footer'
import Loading from './../includes/Loading'
import Functions from '../../utils/functions'
import auth from '../../services/auth'
import { API } from '../../services/api'
import { Carousel, Slide } from 'vue-carousel';
import CouponModal from './CouponModal';
import CouponService from '../../services/coupon';
import Lomadee from '../../drivers/lomadee';
import Rakuten from '../../drivers/rakuten';
import Awin from '../../drivers/awin';
import VueScrollTo from 'vue-scrollto';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faChevronCircleUp} from '@fortawesome/fontawesome-free-solid'
import constants from '../../services/constants';

export default {
  name: 'Projects',
  components: {
    Header,
    Footer,
    Loading,
    Carousel,
    Slide,
    FontAwesomeIcon,
    CouponModal
  },
  data () {
    return {
      loading: false,
      user: null,
      products: [],
      categories: [],
      stores: [],
      featuredStores: [],
      favoriteStores: [],
      coupons: [],
      couponsFeatured: [],
      couponsVitrine: [],
      partnersCoupons: false,
      selectedCoupon: null,
      searchText: null,
      resultStores: null,
      isSearching: false,
      searchLoading: false,
      scrollPosition: 0,
      showScrollButton: false,
      perPage: 6,
      limit: 20
    }
  },
  created(){
    var $this = this;
    if(window.innerWidth < 400){
      this.perPage = 1;
      this.limit = 5;
    }
    var date = new Date();
    var dateString = date.getFullYear() + date.getMonth() + date.getDate();
    if(localStorage.getItem('stores-' + dateString)){
      $this.stores = JSON.parse(localStorage.getItem('stores-' + dateString));
    }
    this.loadProducts();
  },
  mounted (){
    if(auth.isAuth()){
      this.loadProfile();
    }else{
      this.loadStores();
    }
    var $this = this;
    // CouponService.getStores((stores) => {
    //   $this.stores = stores;
    // });
    CouponService.listLomadeeStores((stores, coupons) => {
      $this.featuredStores = stores;
      $this.coupons = coupons.filter((c) => {
        return (c.image !== false)
      });
      $this.couponsFeatured = $this.coupons.slice(0, $this.limit)
      var couponsVitrine = {};
      $this.coupons.map((coupon) => {
        if(coupon.value && coupon.value > 5){
          couponsVitrine[coupon.StoreId] = coupon;
        }
      });

      $this.couponsVitrine = couponsVitrine;
    })
    // Lomadee.getStores().then(res => {
    //   console.log(res.data.stores)
    // })
    // Awin.getStores((res) => {
    //   console.log(res)
    // })
    // Rakuten.getCoupons((res) => {
    //   console.log(res)
    // })
    // Rakuten.getProducts((res) => {
    //   console.log(res)
    // })
    this.scrollToSection();
    this.updateScroll()
    window.addEventListener('scroll', this.updateScroll)
  },
  methods: {
    scrollToSection(){
      if(this.$route.query.section){
        if(this.$route.query.section == 'products'){
          this.$scrollTo('#products', 500, {offset: -80});
        }
        if(this.$route.query.section == 'stores'){
          setTimeout(() => {this.$scrollTo('#stores', 500, {offset: -80})}, 2000);
        }
        if(this.$route.query.section == 'discounts'){
          setTimeout(() => {this.$scrollTo('#latest', 500, {offset: -80})}, 2000);
        }
        let query = Object.assign({}, this.$route.query);
        delete query.section;
        this.$router.replace({ query });
      }
    },
    loadProfile(){
      this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
        this.user = response.body.user;

        this.$http.get(API.Stores.list).then((result) => {
          this.stores = result.body;

          var arrFavoritedStores = [];
          if(this.user.favoritedStoreCategories){
            this.user.favoritedStoreCategories.map((f, i) => {
              var category = constants.STORE_CATEGORIES.filter(c => {
                return c.categoryId == f;
              })
              this.stores.map(s => {
                if(s.Info.categoryId == category[0].categoryId){
                  arrFavoritedStores.push(s);
                }
              });
            })
            this.favoriteStores = arrFavoritedStores;
          }
        });
      });
    },
    openCouponModal(coupon){
      this.selectedCoupon = coupon;
      this.$refs.couponModal.open();
    },
    loadProducts(){
      Lomadee.getProductCategories().then((res) => {
        this.categories = res.data.categories.splice(0, 15);
      });
      Lomadee.getProducts().then((res) => {
        this.products = res.data.offers;
      });
    },
    loadStores(){
      this.$http.get(API.Stores.list).then((result) => {
        this.stores = result.body;
      });
    },
    selectCategory(categoryId){
      this.products = [];
      Lomadee.getProducts(categoryId).then((res) => {
        this.products = res.data.offers;
      })
    },
    searchStore(){
      if(!this.isSearching){
        this.isSearching = true;
        if(this.searchText != null){
          console.log(this.searchText)
          if(this.searchText.length == 0){
            this.clearSearch()
          }else{
            if(this.stores){
              var str = this.searchText.toLowerCase();
              this.resultStores = this.stores.filter((p) => {
                var title = p.Info.name.toLowerCase();
                return title.search(str) !== -1
              });
              this.isSearching = false;
              this.showSearchResult();
            }
          }
        }else{
          this.resultStores = null;
          this.isSearching = false;
        }
      }
    },
    goToLogin(){
      this.$router.push('/login-and-redirect/descontosdobem');
      this.$refs.mustLogin.hide()
    },
    hideModal(){
      this.$refs.mustLogin.hide()
    },
    showMore(){
      var baseTotal = this.couponsFeatured.length;
      var baseFinal = baseTotal + this.limit;
      this.couponsFeatured = this.couponsFeatured.concat(this.coupons.slice(baseTotal, baseFinal));
    },
    clearSearch(){
      this.resultStores = null;
      this.searchText = null;
      this.isSearching = false;
      this.searchLoading = false;
    },
    showSearchResult(){
      this.$refs.searchModal.show();
    },
    getStoreUrl(store)
    {
      var url = '/descontosdobem/store/' + store.slug;
      if(this.$route.query.p){
        url = url + '?p=' + this.$route.query.p;
      }
      return url;
    },
    formatCurrency(number){
      if(number){
        return Functions.numberToReal(number);
      }else{
        return "(Valor Indisponível)";
      }
    },
    updateScroll(){
      this.scrollPosition = window.scrollY;
      if(this.scrollPosition > 20){
        this.showScrollButton = true
      }else{
        this.showScrollButton = false
      }
    },
    scrollToTop(){
      this.$scrollTo('#main', 500);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #main{
    padding-top: 106px;
  }
  #vitrine{
  width: 100%;
  height: auto;
  padding-bottom: 90px;
  background-color: #fff;

  .container-fluid{
    padding-top: 50px;
    padding-bottom: 130px;
    text-align: center;
    background-color: #363b4d;

    h1{
      color: #fff;
      font-size: 34px;
    }
    h4{
      color: #fff;
      font-size: 22px;
    }

    .col-md-12{
      position: relative;

      .searchbar{
        margin-top: 30px;
        input{
          border-radius: 0px !important;
          margin-right: 0px !important;
          width: 70%;
          padding: 20px;
          height: 100%;
          &:first-child{
            border-top-left-radius: 3px !important;
            border-bottom-left-radius: 3px !important;
          }
        }
        button{
          border-radius: 0px !important;
          border-top-right-radius: 3px !important;
          border-bottom-right-radius: 3px !important;
          background-color: #00cc67 !important;
          color: #fff !important;
          border-color: #00cc67 !important;
          padding: 20px;
          font-size: 16px;
          font-weight: bold;
          width:30%
        }
        .advanced-search{
          float: right;
          color: #fff;
          margin-right: 15px;
          margin-top: 5px;
          text-decoration: none;
        }
      }

      .categories-list{
        width: 80%;
        height: 180px;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        position: absolute;
        bottom: -210px;
        left: 10%;
        box-shadow: 0px -20px 20px #363b4d;

        h5{
          margin-top: 70px;
        }

        .VueCarousel{
          margin-top: 30px;
          padding-left: 50px;
          padding-right: 50px;

          .VueCarousel-slide{
            padding: 10px;

            .category{
              cursor: pointer;
              display: block;
              text-decoration: none;
              transition: box-shadow 0.3s ease-in-out;
              position: relative;

              span{
                position: absolute;
                display: block;
                background-color: #00cc67 !important;
                padding: 7px;
                padding-top: 8px;
                padding-bottom: 8px;
                border-radius: 60px;
                color: #fff !important;
                font-weight: bold;
                font-size: 14px !important;
                bottom: -10px;
                right: -10px;
                text-shadow: 1px 1px 1px #666;
              }

              &:hover{
                box-shadow: 0px 1px 5px #999;
              }

              img{
                width: 100%;
              }

              span{
                color: #363b4d;
                font-size: 14px;
              }
            }
          }
        }


      }
    }
  }
}

#featured, #stores, #products{
  width: 100%;
  min-height: 400px;
  padding-bottom: 40px;
  padding-top: 40px;

  .title-section{
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    h3{
      color: #777;
    }
    span{
      color: #666;
    }
  }

  .featured-coupons{
    width: 100%;
    flex-wrap: wrap;
    display: flex;

    .coupon{
      width: 100%;
      padding: 20px;
      padding-top: 10px;
      padding-bottom: 10px;
      margin-top: 20px;
      transition: box-shadow 0.3s ease-in-out;

      &:hover{
        box-shadow: 0px 2px 10px #999;

        .action{
          opacity: 1;
        }
      }
      .image{
        position: relative;

        .flag{
          position: absolute;
          font-size: 12px;
          background-color: red;
          color: #fff;
          padding: 4px;
          top: 10px;
          left: -5px;
          border-radius: 5px;
          box-shadow: 2px 2px 5px #999;
        }
        img{
          width: 100%;
          border-radius: 4px;
        }
      }

      .categorie{
        span{
          font-size: 14px;
          padding-top: 5px;
          padding-bottom: 5px;
          border-bottom: thin solid #ccc;
          width: 100%;
          display: block;
        }
      }

      .coupon-info{
        margin-top: 10px;
        .info{
          h4{
            color: #00cc67;
            font-size: 16px;
          }
          span{
            font-size: 12px;
            display: block;
            width: 100%;
            text-align: justify;

            &.value{
              font-size: 20px;
              font-weight: bold;
              text-align: center;
              padding: 5px;
            }
          }
        }
      }
      .action{
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        button{
          width: 70%;
          background-color: #00cc67;
          color: #fff;
          font-size: 12px;

          &.fav{
            width: 25%;
            background-color: red;
          }
        }
      }
    }
  }
  .view-all{
    width: 100%;
    margin-top: 20px;
    text-align: center;

    button{
      background-color: #00cc67;
      color: #fff;
      padding: 10px;
      padding-left: 30px;
      padding-right: 30px;
      font-size: 14px;
      font-weight: bold;
      border-radius: 50px;
    }
  }
}

#featured{
  background-color: #fff;
}

#stores, #products{
  background-color: '#f7f7f7';
  .store, .product{
    margin-top: 20px;
    .image{
      overflow: hidden;
      text-align: center;
    }
    img{
      width: 70%;
    }
  }

  .category{
    a{
      display: block;
      text-decoration: none;
      color: #00cc67;
      font-weight: bold;
      padding: 10px;
      font-size: 18px;
      cursor: pointer;
      text-align: center;

      &:hover{
        background-color: #00cc67;
        color: #fff;
      }
    }
  }
  .product{
    a{
      display: block;
      text-decoration: none;
    }
    .image{
      position: relative;
      overflow: inherit;
      height: 170px;
      padding-bottom: 40px;
      img{
        width: 50%;
      }
    }
    .price{
      background-color: #00cc67;
      padding: 10px;
      color: #fff;
      border-radius: 10px;
      text-decoration: none;
      text-align: center;
      position: absolute;
      bottom: -10px;
      width: 100%;

      span{
        font-size: 12px;
        text-decoration: line-through;
      }
    }
    .info{
      margin-top: 20px;
      span{
        color: #666;
        font-weight: bold;
      }
      h4{
        color: #00cc67;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .loading-coupons{
    text-align: center;
    margin-top: 30px;
  }
}

#latest{
  width: 100%;
  min-height: 400px;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f7f7f7;

  .title-section{
    padding-bottom: 20px;
    border-bottom: 2px solid #ccc;
    h3{
      color: #777;
    }
    span{
      color: #666;
    }
  }

  .latest-coupons{
    width: 100%;
    flex-wrap: wrap;
    display: flex;

    .loading-coupons{
      text-align: center;
      margin-top: 30px;
    }

    .col-md-6{
      margin-top: 20px;
    }

    .coupon{
      width: 100%;
      margin: 0px !important;
      padding-top: 10px;
      padding-bottom: 10px;
      transition: box-shadow 0.3s ease-in-out;
      background-color: #fff;
      cursor: pointer;

      &:hover{
        box-shadow: 0px 2px 10px #999;

        .action{
          .btn{
            background-color: #00cc67;
            color: #fff;
            border-color: #00cc67;

            &.fav{
              background-color: red;
              border-color: red;
            }
          }
        }
      }
      .image{
        position: relative;

        .flag{
          position: absolute;
          font-size: 12px;
          background-color: red;
          color: #fff;
          padding: 4px;
          top: 10px;
          left: -5px;
          border-radius: 5px;
          box-shadow: 2px 2px 5px #666;
        }
        img{
          border-radius: 4px;
          width: 100%;
        }
      }

      .categorie{
        span{
          font-size: 12px;
          padding-bottom: 5px;
          border-bottom: thin solid #ccc;
          width: 100%;
          display: block;
        }
      }

      .coupon-info{
        margin-top: 10px;
        .info{
          h4{
            color: #00cc67;
            font-size: 16px;
          }
          span{
            font-size: 12px;
            display: block;
            width: 100%;
            text-align: justify;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &.value{
              font-size: 20px;
              font-weight: bold;
              text-align: center;
              padding: 5px;
            }
          }
        }
      }
      .action{
        .btn{
          width: 100%;
          background-color: #f7f7f7;
          border-color: #f7f7f7;
          color: #4b4f5d;
          font-size: 12px;
          font-weight: bold;

          &.fav{
            width: 25%;
          }
        }
      }
    }
  }
  .view-all{
    width: 100%;
    margin-top: 30px;
    text-align: center;

    button{
      background-color: #00cc67;
      color: #fff;
      padding: 10px;
      padding-left: 30px;
      padding-right: 30px;
      font-size: 14px;
      font-weight: bold;
      border-radius: 50px;
    }
  }
}
#searchModal{
    .store{
      padding: 10px;
      width: 100%;
      font-size: 26px;
      a{
        color: #00cc67;
        text-decoration: none;
        &:hover{
          font-weight: bold;
        }
      }
    }
}
#scrollToTop{
  position: fixed;
  z-index: 100;
  bottom: 30px;
  right: 20px;
  background-color: #00AE39;
  border: thin solid #00AE39;
  border-radius: 50px;
  overflow: hidden;
  &:hover{
    opacity: 1;
  }
  a{
    border-radius: 50px;
    display: block;
    font-size: 36px;
    color: #fff;

  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/descontosdobem/Main.vue